import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IconComponentV2 } from '../../../../../shared/components/icon-component/icon.component';
import { ButtonComponent } from '../../../../../shared/components/ui/button/button.component';
import {
  UnpaidPaymentsFundingSourceId,
  UnpaidPaymentsTransferModalData,
  UnpaidPaymentsTransferModalResult,
} from '../../unpaid-payments-modal.types';

@Component({
  selector: 'app-unpaid-payments-transfer-modal',
  standalone: true,
  imports: [CommonModule, IconComponentV2, ButtonComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './unpaid-payments-transfer-modal.component.html',
})
export class UnpaidPaymentsTransferModalComponent {
  private readonly dialogData = inject<UnpaidPaymentsTransferModalData>(MAT_DIALOG_DATA);
  private readonly dialogRef =
    inject<MatDialogRef<UnpaidPaymentsTransferModalComponent, UnpaidPaymentsTransferModalResult | undefined>>(
      MatDialogRef
    );

  readonly title = this.dialogData.title ?? 'Transfer From';
  readonly confirmLabel = this.dialogData.confirmLabel ?? 'Transfer';
  readonly totalAmount = this.dialogData.totalAmount;
  readonly sources = this.dialogData.sources;

  selectedSource: UnpaidPaymentsFundingSourceId | null = this.pickDefaultSource();

  get confirmDisabled(): boolean {
    if (!this.selectedSource) return true;
    const option = this.sources.find((source) => source.id === this.selectedSource);
    return !option || option.availableAmount < this.totalAmount;
  }

  close(): void {
    this.dialogRef.close(undefined);
  }

  selectSource(source: UnpaidPaymentsFundingSourceId): void {
    this.selectedSource = source;
  }

  confirm(): void {
    if (!this.selectedSource || this.confirmDisabled) return;
    this.dialogRef.close({ confirmed: true, source: this.selectedSource });
  }

  private pickDefaultSource(): UnpaidPaymentsFundingSourceId | null {
    const affordable = this.sources.find((source) => source.availableAmount >= this.totalAmount);
    return affordable?.id ?? this.sources[0]?.id ?? null;
  }
}
